<footer class="app-footer">
  <a href="#">WebTrax - Shadow Trackers</a> &copy; Confidence in Hiring.
</footer>
